/*
 * @Author: wangyan1 wangyan1
 * @Date: 2023-10-16 16:53:11
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2024-07-11 14:40:31
 * @FilePath: /teacher-xkh-web/src/service/supervision/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import http from '../http'
import url from './index-url'
const { get, post } = http

export default {
  getSupervisionStudentList(data) {
    return post(url.getSupervisionStudentList, data)
  },
  getAbsenteesStudent(data) {
    return post(url.absenteesStudent, data)
  },
  getLessonsByClassId(data) {
    return get(url.getLessonsByClassId, data)
  },
  lessonList(data) {
    return post(url.lessonList, data)
  },
  hasJzxGroup(data) {
    return get(url.hasJzxGroup, data)
  },
  setPlaystate({ id, status }) {
    return post(url.setPlaystate(id, status))
  },
  speedConfigList(data) {
    return post(url.speedConfigList, data)
  },
  setSpeedState({ id, status }) {
    return post(url.setSpeedState(id, status))
  },
  getGroupLessons(data) {
    return get(url.getGroupLessons, data)
  }
}